"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
exports.__esModule = true;
exports.default = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _objectWithoutPropertiesLoose2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutPropertiesLoose"));
var _inheritsLoose2 = _interopRequireDefault(require("@babel/runtime/helpers/inheritsLoose"));
var _react = _interopRequireDefault(require("react"));
var _reactModal = _interopRequireDefault(require("react-modal"));
require("./Modal.scss");
var _ModalHeader = _interopRequireDefault(require("./ModalHeader"));
var _excluded = ["children"];
var Modal = /*#__PURE__*/function (_React$PureComponent) {
  (0, _inheritsLoose2.default)(Modal, _React$PureComponent);
  function Modal() {
    return _React$PureComponent.apply(this, arguments) || this;
  }
  var _proto = Modal.prototype;
  _proto.componentDidMount = function componentDidMount() {
    // Make sure to bind modal to your appElement (http://reactcommunity.org/react-modal/accessibility/)
    var rootElemId = 'root';
    if (document.getElementById(rootElemId)) {
      _reactModal.default.setAppElement("#" + rootElemId);
    }
  };
  _proto.render = function render() {
    var _this$props = this.props,
      children = _this$props.children,
      otherProps = (0, _objectWithoutPropertiesLoose2.default)(_this$props, _excluded);
    var onRequestClose = otherProps.onRequestClose,
      heading = otherProps.heading,
      headingStyle = otherProps.headingStyle,
      closeIconLeftAligned = otherProps.closeIconLeftAligned,
      _otherProps$innerCont = otherProps.innerContentClassName,
      innerContentClassName = _otherProps$innerCont === void 0 ? '' : _otherProps$innerCont,
      isOpen = otherProps.isOpen,
      icon = otherProps.icon,
      errorNotification = otherProps.errorNotification,
      elementLocator = otherProps.elementLocator;
    return isOpen ? _react.default.createElement(_reactModal.default, (0, _extends2.default)({}, otherProps, {
      overlayClassName: "modal__Overlay modal__Content"
    }), _react.default.createElement("div", {
      className: "modal__InnerContent " + innerContentClassName,
      "data-locator": elementLocator
    }, errorNotification && _react.default.createElement("div", {
      className: "modal_error-notification",
      "data-locator": "modal-error-notification"
    }, errorNotification), _react.default.createElement(_ModalHeader.default, {
      closeFunc: onRequestClose,
      heading: heading,
      closeIconLeftAligned: closeIconLeftAligned,
      headingStyle: headingStyle,
      icon: icon,
      elementLocator: elementLocator
    }), _react.default.createElement("div", {
      className: "modalBodyText"
    }, children))) : null;
  };
  return Modal;
}(_react.default.PureComponent);
Modal.defaultProps = {
  children: null,
  icon: '/static/images/close.svg',
  heading: '',
  headingStyle: '',
  isOpen: false,
  closeIconLeftAligned: false,
  onRequestClose: function onRequestClose() {
    /* default onRequestClose handler */
  },
  elementLocator: ''
};
var _default = Modal;
exports.default = _default;
module.exports = exports["default"];